// removed by extract-text-webpack-plugin
module.exports = {"legend_container":"legend_container__2Yxyk","legend_item":"legend_item__GvbmI","budget_legend_block":"budget_legend_block__QiAX0","expense_legend_block":"expense_legend_block__3h3F4","legend_text":"legend_text__2vCfu","legend_container_left":"legend_container_left__2hZjQ"};


//////////////////
// WEBPACK FOOTER
// ./components/budget-expense-legend/style.scss
// module id = VpSH
// module chunks = 0